<template>
  <div class="content">
    <div class="container-fluid">
      <div class="mt-3">
    <div class="card card-success">
      <div class="card-body">
        <SetupStatus :step="step" :completed_steps="completed_steps" @select_step="(_step) => {step = _step}"/>
      </div>
    </div>
    <template v-if="step===1">
      <h5 class="mb-2">{{ $t('label.update_profile')}}</h5>
      <Profile ref="myProfile" :is-setup-profile="true" @saveAndContinue="handleSaveProfile"/>
    </template>

    <template v-if="step===2">
      <h5 class="mb-2">{{ $t('label.driver')}}</h5>
      <Driver :is-setup-profile="true" :is-setup-driver="false" :drivers="drivers" :profile="profile" @saveAndContinue="handleSaveDriver" @back="handleBackButton"></Driver>
    </template>
    <template v-if="step===3">
      <h5 class="mb-2">{{ $t('label.vehicle')}}</h5>
      <FormCreateVehicle :is-setup-profile="true" :is-setup-vehicle="false" :vehicle_uuid="vehicle_uuid" @saveAndContinue="handleSaveVehicle" @back="handleBackButton"/>
    </template>

  </div>
    </div>
  </div>
</template>

<script>
import SetupStatus from "./SetupStatus";
import Profile from "../../components/Profile/ProfileNew";
import Driver from "../../components/driver/DriverNew";
import FormCreateVehicle from "../../components/vehicle/FormNew";
export default {
  name: "Setup",
  components: {
    Profile,
    Driver,
    FormCreateVehicle,
    SetupStatus,
  },
  data(){
    return {
      step:1,
      profile: {},
      drivers: [],
      vehicles: [],
      completed_steps: [],
      is_also_driver: false,
      vehicle_uuid: null,
    }
  },
  watch: {
    completed_steps: function () {
      this.renderSteps();
    }
  },
  mounted() {
    this.getProfile();
    this.getDrivers();
    this.getVehicles();
  },
  methods:{
    handleSaveProfile(is_also_driver){
      if(typeof is_also_driver === "undefined"){
        is_also_driver = false;
      }
      if(is_also_driver){
        this.step = 3;
        this.addCompletedStep(1);
        this.addCompletedStep(2);
      }else{
        this.step = 2;
        this.addCompletedStep(1);
        this.removeCompletedStep(2);
      }
      this.getProfile();
      this.getDrivers();
    },
    handleSaveDriver(){
      this.step+=1;
      this.addCompletedStep(2);
      this.getDrivers();
    },
    handleSaveVehicle(){
      this.step+=1;
      this.addCompletedStep(3);
      if(this.step > 3) this.step = 3;
      this.getVehicles();
    },
    handleBackButton: function () {
      if(this.step>1){
        this.step-=1;
      }
    },
    getProfile(){
      this.profile = {};
      GDCE_Client.requestApi("GET", 'profile').then(response => {
        if (response.data.first_name !== null && response.data.last_name !== null
            && response.data.nationality !== null && response.data.nationality_code !== null
            && response.data.identity_card_number !== null && response.data.identity_card_issued_date !== null
            && response.data.identity_card_expired_date !== null && response.data.address !== null)
        {
          if(response.data.driver_uuid === null){
            this.addCompletedStep(1);
            this.removeCompletedStep(2);
            this.step=2;
          }else{
            this.addCompletedStep(1);
            this.addCompletedStep(2);
            this.step=3;
          }
          if(response.data){
            this.profile = response.data;
          }
        }

      });
    },
    getDrivers () {
      this.drivers = [];
      GDCE_Client.requestApi("GET", 'drivers').then(response => {
        if(response.status && response.data.data.length > 0){
          this.addCompletedStep(2);
          this.step=3;
          if(response.data){
            this.drivers = response.data.data;
          }
        }
      });
    },
    getVehicles() {
      this.vehicles = [];
      GDCE_Client.requestApi("GET", 'vehicles').then(response => {
        if(response.status && response.data.data.length > 0){
          this.addCompletedStep(3);
          this.step=3;
          if(response.data){
            this.vehicles = response.data.data;
            this.vehicle_uuid = this.vehicles[0].uuid;
          }
        }
      });
    },
    addCompletedStep(step){
      if(!this.completed_steps.includes(step)){
        this.completed_steps.push(step);
      }
    },
    removeCompletedStep(step){
      if(this.completed_steps.indexOf(step) > -1){
        console.log(this.completed_steps.indexOf(step))
        this.completed_steps.splice(step,1);
      }
    },
    renderSteps(){
      if(!this.completed_steps.includes(1)){
        this.step = 1;
      }else if(!this.completed_steps.includes(2)){
        this.step = 2;
      }else if(!this.completed_steps.includes(3)){
        this.step = 3;
      }else{
        this.$router.push({ name: "CreateApplication" });
      }
    }
  }
}
</script>

<style scoped>
</style>